import http from "./http";
const baseUrl = "/v1/api/app";

const { get, post } = http;

const getProductManagePage = (params: any) => post(`${baseUrl}/product/page`, params); // 我的产品列表
const getProductManageNoPage = (params: any) => post(`${baseUrl}/product/list`, params); // 我的产品列表不带分页
const getProductManageDetail = (params: any) => post(`${baseUrl}/product/detail`, params); // 产品详情
const deleteProductManage = (params: any) => post(`${baseUrl}/product/delete`, params); // 删除我的产品
const createProductManage = (params: any) => post(`${baseUrl}/product/create`, params); // 产品创建
const existNameProductManage = (params: any) => post(`${baseUrl}/product/name/exist`, params); // 检查名称
const saveProductManage = (params: any) => post(`${baseUrl}/product/save`, params); // 保存产品详情
export default {
    getProductManagePage,
    getProductManageNoPage,
    getProductManageDetail,
    deleteProductManage,
    createProductManage,
    existNameProductManage,
    saveProductManage,
}